import React from "react";
import './PanelAdministracion.scss'
import panel  from "../../../../assets/img/paneles/administrativo.png";
import GlobalCard from "../../../../components/atoms/GlobalCard/GlobalCard";
const PanelAdministracion = ()=>
{
    return(
        <div className="PanelAdministracion">
            <GlobalCard>
            <img src={panel} alt="" />
            </GlobalCard>
        </div>
    )
}
export default PanelAdministracion